/**
 * Maps a `summary_ready` notification's body to the current UI language.
 *
 * The backend always stores the same literal English sentence for this kind
 * (see `postgres_ingest._notify_summary_ready`), so — same as
 * `recordingFailureMessage` for `recording_failed` — the raw `body` is never
 * rendered directly; it is replaced with the translation of a fixed key.
 */

type Translate = (key: string, vars?: Record<string, string | number>) => string

export function summaryReadyBody(t: Translate): string {
  return t('notifications.summaryReady.body')
}
